module.exports = __webpack_public_path__ + "img/healthCheck-active.c0341da7.svg";